import { createAction } from 'redux-actions';

const actions = {
  /**
   * [상품 공지사항] 상품 공지사항 데이터 변경하기
   */
  SET_DATA: 'notice/product/SET_DATA',
  setData: createAction('notice/product/SET_DATA'),

  /**
   * [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
   */
  GET_NOTICE_PRODUCT_LIST_REQUEST: 'notice/product/GET_NOTICE_PRODUCT_LIST_REQUEST',
  GET_NOTICE_PRODUCT_LIST_SUCCESS: 'notice/product/GET_NOTICE_PRODUCT_LIST_SUCCESS',
  getNoticeProductList: createAction('notice/product/GET_NOTICE_PRODUCT_LIST_REQUEST'),

  /**
   * [상품 공지사항 리스트] 상품 공지사항 리스트 엑셀 다운로드 하기
   */
  GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST: 'notice/product/GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST',
  GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_SUCCESS: 'notice/product/GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_SUCCESS',
  getNoticeProductExcelDownload: createAction('notice/product/GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [상품 공지사항 리스트] 공지사항 삭제 요청하기
   */
  DELETE_NOTICE_PRODUCT_REQUEST: 'notice/product/DELETE_NOTICE_PRODUCT_REQUEST',
  deleteNoticeProduct: createAction('notice/product/DELETE_NOTICE_PRODUCT_REQUEST'),

  /**
   * [상품 공지사항 상세] 상품 공지사항 상세 데이터 요청하기
   */
  GET_NOTICE_PRODUCT_INFO_REQUEST: 'notice/product/GET_NOTICE_PRODUCT_INFO_REQUEST',
  GET_NOTICE_PRODUCT_INFO_SUCCESS: 'notice/product/GET_NOTICE_PRODUCT_INFO_SUCCESS',
  getNoticeProductInfo: createAction('notice/product/GET_NOTICE_PRODUCT_INFO_REQUEST'),

  /**
   * [상품 공지사항 상세] 상품 공지사항에 등록된 상품 목록 구하기
   */
  GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST: 'notice/product/GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST',
  GET_NOTICE_PRODUCT_ITEM_INFO_SUCCESS: 'notice/product/GET_NOTICE_PRODUCT_ITEM_INFO_SUCCESS',
  getNoticeProductItemInfo: createAction('notice/product/GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'notice/product/TOGGLE_MODAL',
  toggleModal: createAction('notice/product/TOGGLE_MODAL'),
};

export default actions;
